import React, { Component, useState, useEffect, useRef } from "react";
import HeaderBooking from "../../components/HeaderBooking";
import HeaderDashboard from "../../components/HeaderDashboard";
import json from "../../assets/JSONs/quiz_data_format.json";
import "./index.css";
import "Containers/Booking Selection/index.css";
import ReactFullpage from "@fullpage/react-fullpage";
import CheckIcon from "@material-ui/icons/Check";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import LinearProgress from "@material-ui/core/LinearProgress"; // Import LinearProgress
import {
  loadSpecificQuiz,
  loadSpecificQuizQuestions,
  loadResult,
  loadQuizNumber,
  calculateQuizScore,
} from "../../actions/quiz";
import { logout } from "../../actions/auth";
import Loading from "../../components/Utilities/Loading/Loading";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { useHistory, useParams } from "react-router";
import { useLocation } from "react-router-dom";
import PageNotFound from "../../screens/PageNotFound/PageNotFound.js";
import {
  logoutUser,
  setUserCoins,
  startLoading,
  stopLoading,
} from "store/actions";
import { useUserInfoSelector, useUserTokenSelector } from "store/reducers";
import { useDispatch } from "react-redux";
import { markActivityComplete } from "actions/dataLoad";
import { MdArrowBackIos } from "react-icons/md";
import { makeStyles } from "@material-ui/core";

const AssessmentQuiz = (props) => {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [quizNum, setQuizNum] = useState(null);
  const [quizName, setquizName] = useState([]);
  const [imageurl, setImageurl] = useState("");
  const userToken = useUserTokenSelector();
  const userInfo = useUserInfoSelector();
  const [open, setOpen] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  const [quizNotFound, setQuizNotFound] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { activityId } = location?.state || {};
  const { urlSlug } = useParams();

  const handleLogout = () => {
    logout(userToken);

    logoutUser(dispatch);

    window.localStorage.removeItem("auth");

    history.push({
      pathname: "/signin",
      state: {
        loggedOutMessage: "You have been logged out. Please login again.",
      },
    });
  };

  const showError = (text) => {
    setError(text);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      setOpen(false);
    }
    setOpen(false);
  };

  const showResultAlert = (text) => {
    setResult(text);
    setOpenResult(true);
  };

  const handleCloseResult = (event, reason) => {
    if (reason === "clickaway") {
      setOpenResult(false);
    }
    setOpenResult(false);
  };
  const getQuizNumber = async (urlSlug) => {
    try {
      const quiz = await loadQuizNumber(urlSlug, userToken);
      return Number(quiz.data.number);
    } catch (error) {
      setQuizNotFound(true);
    }
  };
  useEffect(() => {
    loadAllQuizData();
  }, []);

  useEffect(() => {
    const rootElement = document.getElementById("root");
    const originalOverflow = window
      .getComputedStyle(rootElement)
      .getPropertyValue("overflow");
    rootElement.style.overflow = "hidden";

    // Cleanup function to reset the overflow when the component is unmounted or cleaned up
    return () => {
      rootElement.style.overflow = originalOverflow; // Reset the overflow when cleaning up
    };
  }, []);

  const loadAllQuizData = async () => {
    try {
      dispatch(startLoading());
      const quizNo = await getQuizNumber(urlSlug);
      setQuizNum(quizNo);

      const res = await loadSpecificQuiz(quizNo, userToken);

      const { name, answers, imageUrl } = res.data;
      setAnswers(answers);
      setquizName(name);
      setImageurl(imageUrl);
      const questionRes = await loadSpecificQuizQuestions(quizNo, userToken);
      setQuestions(questionRes.data);
    } catch (err) {
      if (err.response?.data?.redirectToSignIn) {
        showError(err.response.data.error);
        setTimeout(
          () =>
            history.push({
              pathname: "/signin",
              state: { referer: location.pathname },
            }),
          3000
        );
      } else {
        console.log(err);
        showError(err.response);
      }
    } finally {
      dispatch(stopLoading());
    }
  };

  const activityComplete = async (activityId) => {
    try {
      const response = await markActivityComplete(
        userToken,
        userInfo.id,
        activityId
      );
      const { status, error, coinsBalance } = response.data;
      if (status !== "success") {
        throw new Error(error);
      }
      if (coinsBalance) {
        dispatch(setUserCoins(coinsBalance));
      }
    } catch (error) {
      console.error("Failed to complete activity: ", error.message);
    }
  };

  const showResult = async (allAnswers) => {
    try {
      dispatch(startLoading());
      const response = await calculateQuizScore(quizNum, allAnswers, userToken);
      const { score } = response.data;
      if (activityId) {
        activityComplete(activityId);
      }
      history.push(`/dashboard/assessments/results/${urlSlug}?sum=${score}`);
    } catch (error) {
      console.error("Failed to calculate score: ", error.message);
      showError("Could not calculate your score. Please try again.");
    } finally {
      dispatch(stopLoading());
    }
  };
  if (quizNotFound) {
    return <PageNotFound />;
  }
  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {error}
        </Alert>
      </Snackbar>
      {/*<Snackbar
        open={openResult}
        autoHideDuration={6000}
        onClose={handleCloseResult}
      >
        <Alert
          onClose={handleCloseResult}
          severity='info'
          sx={{ width: "100%" }}
        >
          {result}
        </Alert>
      </Snackbar>*/}
      {questions.length !== 0 && (
        <Quiz
          answers={answers}
          questions={questions}
          quizName={quizName}
          imageurl={imageurl}
          showResult={showResult}
          handleLogout={handleLogout}
          result={result}
          openResult={openResult}
        />
      )}
    </div>
  );
};

const Quiz = ({
  answers,
  questions,
  quizName,
  imageurl,
  showResult,
  handleLogout,
  result,
  openResult,
}) => {
  const [allAnswers, setAllAnswers] = useState(
    new Array(questions.length).fill(null)
  );
  const [exitWarning, setExitWarning] = useState(false);
  const useStyles = makeStyles((theme) => ({
    root: {
      height: 5,
      width: "95%",
      marginBottom: "10px",
      backgroundColor: "#d2d2d2",
      borderRadius: 5,
    },
    bar: {
      backgroundColor: "#22c55e",
      borderRadius: 5,
    },
  }));
  const classes = useStyles();
  const history = useHistory();

  const checkValidity = () => {
    return allAnswers.length === 0 || allAnswers.includes(null);
  };
  useEffect(() => {
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverscroll = document.documentElement.style.overscrollBehavior;
    const prevBodyOverscroll = document.body.style.overscrollBehavior;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.documentElement.style.overscrollBehavior = "none";
    document.body.style.overscrollBehavior = "none";
    const blockScroll = (e) => {
      e.preventDefault();
    };
    window.addEventListener("wheel", blockScroll, { passive: false });
    window.addEventListener("touchmove", blockScroll, { passive: false });
    if (window.fullpage_api) {
      window.fullpage_api.setAllowScrolling(false);
      window.fullpage_api.setKeyboardScrolling(false);
    }
    return () => {
      if (window.fullpage_api) {
        window.fullpage_api.setAllowScrolling(true);
        window.fullpage_api.setKeyboardScrolling(true);
      }
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overscrollBehavior = prevHtmlOverscroll;
      document.body.style.overscrollBehavior = prevBodyOverscroll;
      window.removeEventListener("wheel", blockScroll);
      window.removeEventListener("touchmove", blockScroll);
    };
  }, []);

  const exit = () => {
    history.push("/dashboard/assessments");
  };

  return (
    <>
      <div className="sectionpageassessmnet">
        <ReactFullpage
          licenseKey={"YOUR_KEY_HERE"}
          scrollingSpeed={1000}
          autoScrolling={true}
          fitToSection={true}
          scrollOverflow={false}
          render={({ state, fullpageApi }) => {
            return (
              <ReactFullpage.Wrapper>
                {questions &&
                  questions.map((e, i) => {
                    const options = e.answers && e.answers.length > 0 ? e.answers : answers;
                    return (
                      <div
                        className={`section ${i === 0 ? "active" : ""}`}
                        key={i}
                      >
                        <div className="halfcontainerquiz">
                          <p className="title-hcqs">
                            <MdArrowBackIos
                              className="back-icon"
                              onClick={() => {
                                setExitWarning(true);
                              }}
                            />
                            {quizName}
                          </p>
                          {/* Replaced custom progress bar with Material-UI LinearProgress */}
                          <LinearProgress
                            variant="determinate"
                            classes={{
                              root: classes.root,
                              bar: classes.bar,
                            }}
                            value={((i + 1) / questions.length) * 100}
                          />

                          <div className="subtitle-hcqs">
                            <p className="q-number">{i + 1}</p>
                            <p>{e.question}</p>
                          </div>
                          {options.map((u) => {
                            return (
                              <div
                                className={`select-box-lcb ${
                                  allAnswers[i] && allAnswers[i].selectedOption === u.answer ? "selected" : ""
                                }`}
                                onClick={() => {
                                  const newArr = [...allAnswers];
                                  newArr[i] = { questionId: e._id, selectedOption: u.answer };
                                  setAllAnswers(newArr);
                                  if (i < questions.length - 1) {
                                    fullpageApi.moveSectionDown();
                                  }
                                }}
                              >
                                <div className="top-sblcb">
                                  <p className="quizOptions">{u.answer}</p>
                                </div>
                              </div>
                            );
                          })}
                          <div className="btns-quiz-updown">
                            {i > 0 && i < questions.length - 1 && (
                              <button
                                style={{ color: "#394B42", fontWeight: "600" }}
                                onClick={() => {
                                  fullpageApi.moveSectionUp();
                                }}
                              >
                                Previous{" "}
                              </button>
                            )}
                            {questions && i < questions.length - 1 ? (
                              <button
                                className={`next-btn ${
                                  allAnswers[i] !== null ? "active" : ""
                                }`}
                                disabled={allAnswers[i] === null}
                                onClick={() => {
                                  if (allAnswers[i] !== null) {
                                    fullpageApi.moveSectionDown();
                                  }
                                }}
                              >
                                Next{" "}
                              </button>
                            ) : (
                              <button
                                className={`show-res ${
                                  checkValidity() ? "" : "active"
                                }`}
                                disabled={checkValidity()}
                                style={{
                                  color: "#FFFCF8",
                                  fontWeight: "800",
                                  width: "100%",
                                }}
                                onClick={() => {
                                  showResult(allAnswers);
                                }}
                              >
                                <span className="button-text">See Results</span>
                                <span className="button-icon">
                                  <ArrowForwardIcon />
                                </span>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </ReactFullpage.Wrapper>
            );
          }}
        />
        {exitWarning && (
          <div className="popup-spassessment-cont">
            <div className="popup-spassessment">
              <h2>Are you sure you want to exit?</h2>
              <p style={{ textAlign: "center" }}>
                <span>If you exit now, your answers won't be saved</span>
              </p>
              <div className="buttons-pspa">
                <button onClick={exit}>Yes, Exit</button>
                <button onClick={() => setExitWarning(false)}>No</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AssessmentQuiz;
